import config from "./config";

export const amplifyConfiguration = {
  Auth: {
    mandatorySignIn: true,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID,
    // Added OAuth block to support hosted UI & One Tap fallback flows
    oauth: {
      // Hosted UI domain matches CloudFormation UserPoolDomain: eleplan-{stage}
      // Rely on REACT_APP_STAGE to mirror serverless stage naming.
      domain: `${config.system.name}-${process.env.REACT_APP_STAGE || 'development'}.auth.${config.cognito.REGION}.amazoncognito.com`,
      scope: ['openid', 'email', 'profile', 'phone', 'aws.cognito.signin.user.admin'],
      // NOTE: Avoid trailing slash to exactly match Cognito User Pool Client CallbackURLs entry
      redirectSignIn: window.location.origin,
      redirectSignOut: window.location.origin,
      responseType: 'code', // using code flow; tokens exchanged internally
    }
  },
  Storage: {
    region: config.s3.REGION,
    bucket: config.s3.BUCKET,
    identityPoolId: config.cognito.IDENTITY_POOL_ID
  },
  API: {
    endpoints: config.apiGateway
  }
};
